import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchTestimonials } from "../services/api";

export const getTestimonials = createAsyncThunk("testimonials/fetch", async () => {
  const response = await fetchTestimonials();
  return response;
});

const testimonialsSlice = createSlice({
  name: "testimonials",
  initialState: { data: [], status: "idle" },
  extraReducers: (builder) => {
    builder
      .addCase(getTestimonials.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getTestimonials.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload;
      })
      .addCase(getTestimonials.rejected, (state) => {
        state.status = "failed";
      });
  },
});

// Keep existing named export used by store.js
export const testimonialsReducer = testimonialsSlice.reducer;
export default testimonialsSlice.reducer;